import 'magnific-popup';

import API from './components/api';

import Header from './components/header';
import Slider from './components/slider';
import InteriorsSlider from './components/interiorsSlider';
import StocksSlider from './components/stocksSlider';
import MasonryGrid from './components/masonryGrid';

import Map from './components/map';
import Tabs from './components/tabs';
import Filter from './components/filter';
import Search from './components/search';
import ShopFilter from './components/shopFilter';
import Schema from './components/scheme';
import BrandsFilter from './components/brandsFilter';


$(function () {
    new Header();

    new MasonryGrid();

    new StocksSlider();

    new Schema();

    const $productSlider = $('.js-products-slider');
    if ($productSlider) {
        $productSlider.each(function(idx, node) {
            new InteriorsSlider({
                node: $(node)
            });
        });
    }

    const $brands = $('.js-brands-container');
    if ($brands) {
        new BrandsFilter({
            node: $brands
        });
    }

    const $sliders = $('.js-slider');
    if ($sliders.length) {
        $sliders.each(function(idx, node) {
            new Slider({
                node: $(node)
            }).init();
        });
    }

    const $map = $('#map');
    window.ymaps && $map.length && ymaps.ready(function () {
        new Map({
            element: $map
        });
    });

    const $tabs = $('.js-tabs');
    if ($tabs.length) {
        const linkElement = $tabs.find('.tabs__link');
        const paneElement = $tabs.find('.tabs__pane');

        new Tabs({
            rootElement: $tabs,
            linkElement,
            paneElement
        });
    }

    const $filter = $('.js-filter');
    if ($filter.length) {
        $filter.each(function(idx, node) {
            new Filter({
                $node: $(node)
            }).init();
        });
    }

    const $search = $('.js-search');
    if ($search.length) {
        new Search({
            $node: $search
        }).init();
    }

    const $shopFilter = $('.js-shop-filter');
    if ($shopFilter.length) {
        new ShopFilter({
            $node: $shopFilter
        }).init();
    }

    /* Popups */
    // $.magnificPopup.instance.open = function (data) {
    //     $body.addClass('popup-is-open');
    //     $.magnificPopup.proto.open.call(this, data);
    // };
    //
    // $.magnificPopup.instance.close = function () {
    //     $.magnificPopup.proto.close.call(this);
    //     $body.removeClass('popup-is-open');
    // };
    //
    // const $popupLinks = $('.js-open-popup');
    //
    // if ($popupLinks.length) {
    //     $popupLinks.magnificPopup({
    //         type: 'inline'
    //     });
    //
    //     $('.js-popup-close').on('click', e => {
    //         console.log('close');
    //         e && e.preventDefault && e.preventDefault();
    //         $.magnificPopup.instance.close();
    //     });
    // }


    $('.js-simple-form').submit(function (e) {
        const url = $(this).attr('action');
        const data = $(this).serialize();

        API.get({
            url,
            data
        });

        return false;
    });
});





// WEBPACK FOOTER //
// ./app.js